interface Props {
  message: string;
  onConfirm: () => void;
}

export default function ForceLogoutModal({ message, onConfirm }: Props) {
  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center">
      {/* Backdrop - 클릭으로 닫기 불가 */}
      <div className="absolute inset-0 bg-black/50" />

      {/* Modal */}
      <div className="relative bg-white rounded-xl shadow-xl w-full max-w-sm mx-4 p-6 text-center">
        <div className="size-12 mx-auto mb-4 rounded-full bg-red-100 flex items-center justify-center">
          <svg className="size-6 text-red-600" fill="none" viewBox="0 0 24 24" strokeWidth={2} stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" d="M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126ZM12 15.75h.007v.008H12v-.008Z" />
          </svg>
        </div>
        <h3 className="text-lg font-bold text-gray-900 mb-2">세션 종료</h3>
        <p className="text-sm text-gray-600 mb-6">{message}</p>
        <button
          onClick={onConfirm}
          className="w-full px-4 py-2.5 text-sm font-medium text-white bg-primary-600 rounded-lg hover:bg-primary-700 transition-colors"
        >
          다시 로그인
        </button>
      </div>
    </div>
  );
}
